import React, { useEffect, useState } from "react";

import { CircularProgress, Stack } from "@mui/material";

import { CommentInput } from "./CommentInput";
import { CommentsList } from "./CommentsList";
import { fetchComments } from "./mockData";
import { NewsComment } from "./types";

interface Props {
  isOpen: boolean;
  currentUserAvatarUrl?: string;
  onAddComment?: (text: string) => void;
  onReply?: (commentId: string, text: string) => void;
}

export const NewsComments: React.FC<Props> = ({ isOpen, currentUserAvatarUrl, onAddComment, onReply }) => {
  const [comments, setComments] = useState<NewsComment[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (!isOpen) return;
    if (isLoading) return;

    setIsLoading(true);
    fetchComments()
      .then((fetchedComments) => {
        setComments(fetchedComments);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [isOpen]);

  const handleAddComment = (text: string) => {
    if (onAddComment) {
      onAddComment(text);
    }
    // After posting, just push to array:
    // const newComment: NewsComment = { id: generateId(), parent_id: null, ... };
    // setComments(prev => [...prev, newComment]);
  };

  return (
    <Stack sx={{ gap: "20px", height: "100%", display: "flex", flexDirection: "column", overflow: "hidden" }}>
      <CommentInput currentUserAvatarUrl={currentUserAvatarUrl} onAddComment={handleAddComment} />
      {isLoading ? (
        <Stack
          alignItems="center"
          justifyContent="center"
          sx={{
            py: "40px",
            flex: 1,
            minHeight: 0,
            overflow: "hidden"
          }}
        >
          <CircularProgress size={40} sx={{ color: "#496682" }} />
        </Stack>
      ) : (
        <Stack
          sx={{
            flex: 1,
            minHeight: 0,
            overflowY: "auto",
            overflowX: "hidden",
            "&::-webkit-scrollbar": {
              width: "8px"
            },
            "&::-webkit-scrollbar-track": {
              background: "#f1f1f1",
              borderRadius: "4px"
            },
            "&::-webkit-scrollbar-thumb": {
              background: "#888",
              borderRadius: "4px",
              "&:hover": {
                background: "#555"
              }
            }
          }}
        >
          <CommentsList comments={comments} onReply={onReply} currentUserAvatarUrl={currentUserAvatarUrl} />
        </Stack>
      )}
    </Stack>
  );
};
